import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {appendQueryString, catch400, catch404, getRequest} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {enable301ResponseState} from "@pg-mono/response-state";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {redirectOrEnable404ResponseState} from "../../../errors/actions/page_404_actions";
import {getOfferListSortName} from "../../helpers/get_offer_list_sort_name";
import {OFFER_LIST_PAGE_SIZE} from "../constants/offer_list";
import {SearchSortString} from "../constants/SearchSort";
import {IOfferListResponse} from "../types/IOfferListResponse";

const UNAVAILABLE_OFFER_LIST = "offer_list/UNAVAILABLE_OFFER_LIST";
export const fetchUnavailableOfferListTypes = createRequestActionTypes(UNAVAILABLE_OFFER_LIST);

// "s" query param clashes with scenario parameter when searching Google Places
export const UNAVAILABLE_CONSTRAINTS_TO_STRIP = ["limited_presentation", "display_type", "for_sale", "show_on_listing", "distance", "s"];

export const resetUnavailableOfferList = () => ({type: fetchUnavailableOfferListTypes.reset});

export const fetchUnavailableOfferList =
    (ctx: IFetchContext<IRPRequestMeta>, urlPage: number, activeCount: number, query: Record<string, string | string[] | null>) =>
    async (dispatch: Dispatch) => {
        dispatch({type: fetchUnavailableOfferListTypes.start});

        const offerListLink = apiV2ListLink.offer.list(Scenario.OFFER_LIST);
        const filteredQuery = Object.fromEntries(Object.entries(query).filter(([key]) => !UNAVAILABLE_CONSTRAINTS_TO_STRIP.includes(key) && key !== "page"));

        const userSorts = (Array.isArray(query.sort) ? query.sort : query.sort ? [query.sort] : [])
            .map((s) => getOfferListSortName(s as SearchSortString, false))
            .filter(Boolean);
        const baseQuery = {
            ...filteredQuery,
            limited_presentation: true,
            sort: ["active_hold_archived", ...userSorts],
            page_size: OFFER_LIST_PAGE_SIZE,
            distance: 0
        };

        const pageSize = OFFER_LIST_PAGE_SIZE;
        const activeLastPage = activeCount > 0 ? Math.ceil(activeCount / pageSize) : 1;
        // How many active offers occupy the last active page (0 means the last page is full)
        const activeLastPageRemainder = activeCount % pageSize;
        // How many URL pages past the last active page the current page is (0 = transition page)
        const unavailablePageOffset = urlPage - activeLastPage;

        // Last active page is full — no room for unavailable offers on it (only when there are active offers)
        if (unavailablePageOffset === 0 && activeCount > 0 && activeLastPageRemainder === 0) {
            dispatch({type: fetchUnavailableOfferListTypes.success, result: {offers: [], count: 0, page: urlPage}});
            return;
        }

        const fetchPage = (page: number) => getRequest(ctx.meta, appendQueryString(offerListLink, {...baseQuery, page})) as Promise<IOfferListResponse>;

        const fetchPageOrEmpty = (page: number): Promise<IOfferListResponse> =>
            fetchPage(page).catch(catch404(() => ({count: 0, results: []}) as unknown as IOfferListResponse));

        // How many unavailable offers the transition page (where active offers end) already consumed.
        // 0 only when that page was entirely taken up by a full page of active offers (handled above).
        const transitionSlots = activeCount > 0 && activeLastPageRemainder === 0 ? 0 : pageSize - activeLastPageRemainder;

        const handleOutOfRangePage = () => {
            if (urlPage > 1) {
                const {page: _page, ...restQuery} = ctx.route.query;
                dispatch(enable301ResponseState(appendQueryString(ctx.route.pathname, restQuery)));
            } else {
                dispatch(redirectOrEnable404ResponseState(ctx.route.pathname, ctx.meta));
            }
        };

        const doFetch = async () => {
            if (unavailablePageOffset === 0) {
                // Transition page: active offers already in store, append first slice of unavailable
                const response = await fetchPageOrEmpty(1);
                return {offers: response.results.slice(0, transitionSlots), totalCount: response.count};
            }

            // Global index range (within the combined unavailable sequence) this URL page should cover
            const rangeStart = transitionSlots + (unavailablePageOffset - 1) * pageSize;
            const firstApiPage = unavailablePageOffset;

            const firstResponse = await fetchPageOrEmpty(firstApiPage);
            const totalCount = firstResponse.count;

            if (rangeStart >= totalCount) {
                // Every unavailable offer was already shown on an earlier page — this URL page doesn't exist
                return null;
            }

            const rangeEnd = Math.min(rangeStart + pageSize, totalCount);
            const firstPageGlobalStart = (firstApiPage - 1) * pageSize;
            const fromFirstPage = firstResponse.results.slice(rangeStart - firstPageGlobalStart, rangeEnd - firstPageGlobalStart);

            if (fromFirstPage.length >= rangeEnd - rangeStart || firstResponse.results.length < pageSize) {
                return {offers: fromFirstPage, totalCount};
            }

            // Requested range spills onto the next API page
            const nextResponse = await fetchPageOrEmpty(firstApiPage + 1);
            return {offers: [...fromFirstPage, ...nextResponse.results].slice(0, rangeEnd - rangeStart), totalCount};
        };

        return doFetch()
            .then((fetchResult) => {
                if (fetchResult === null) {
                    handleOutOfRangePage();
                    return;
                }
                dispatch({
                    type: fetchUnavailableOfferListTypes.success,
                    result: {offers: fetchResult.offers, count: fetchResult.totalCount, page: urlPage}
                });
            })
            .catch(
                catch400((error) => {
                    dispatch({type: fetchUnavailableOfferListTypes.error, error: error.appError});
                })
            )
            .catch(catch404(handleOutOfRangePage));
    };
import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {appendQueryString, catch400, catch404, getRequest} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {enable301ResponseState} from "@pg-mono/response-state";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {redirectOrEnable404ResponseState} from "../../../errors/actions/page_404_actions";
import {getOfferListSortName} from "../../helpers/get_offer_list_sort_name";
import {OFFER_LIST_PAGE_SIZE} from "../constants/offer_list";
import {SearchSortString} from "../constants/SearchSort";
import {IOfferListResponse} from "../types/IOfferListResponse";

const UNAVAILABLE_OFFER_LIST = "offer_list/UNAVAILABLE_OFFER_LIST";
export const fetchUnavailableOfferListTypes = createRequestActionTypes(UNAVAILABLE_OFFER_LIST);

// "s" query param clashes with scenario parameter when searching Google Places
export const UNAVAILABLE_CONSTRAINTS_TO_STRIP = ["limited_presentation", "display_type", "for_sale", "show_on_listing", "distance", "s"];

export const resetUnavailableOfferList = () => ({type: fetchUnavailableOfferListTypes.reset});

export const fetchUnavailableOfferList =
    (ctx: IFetchContext<IRPRequestMeta>, urlPage: number, activeCount: number, query: Record<string, string | string[] | null>) =>
    async (dispatch: Dispatch) => {
        dispatch({type: fetchUnavailableOfferListTypes.start});

        const offerListLink = apiV2ListLink.offer.list(Scenario.OFFER_LIST);
        const filteredQuery = Object.fromEntries(Object.entries(query).filter(([key]) => !UNAVAILABLE_CONSTRAINTS_TO_STRIP.includes(key) && key !== "page"));

        const userSorts = (Array.isArray(query.sort) ? query.sort : query.sort ? [query.sort] : [])
            .map((s) => getOfferListSortName(s as SearchSortString, false))
            .filter(Boolean);
        const baseQuery = {
            ...filteredQuery,
            limited_presentation: true,
            sort: ["active_hold_archived", ...userSorts],
            page_size: OFFER_LIST_PAGE_SIZE,
            distance: 0
        };

        const pageSize = OFFER_LIST_PAGE_SIZE;
        const activeLastPage = activeCount > 0 ? Math.ceil(activeCount / pageSize) : 1;
        // How many active offers occupy the last active page (0 means the last page is full)
        const activeLastPageRemainder = activeCount % pageSize;
        // How many URL pages past the last active page the current page is (0 = transition page)
        const unavailablePageOffset = urlPage - activeLastPage;

        // Last active page is full — no room for unavailable offers on it (only when there are active offers)
        if (unavailablePageOffset === 0 && activeCount > 0 && activeLastPageRemainder === 0) {
            dispatch({type: fetchUnavailableOfferListTypes.success, result: {offers: [], count: 0, page: urlPage}});
            return;
        }

        const fetchPage = (page: number) => getRequest(ctx.meta, appendQueryString(offerListLink, {...baseQuery, page})) as Promise<IOfferListResponse>;

        const fetchPageOrEmpty = (page: number): Promise<IOfferListResponse> =>
            fetchPage(page).catch(catch404(() => ({count: 0, results: []}) as unknown as IOfferListResponse));

        // How many unavailable offers the transition page (where active offers end) already consumed.
        // 0 only when that page was entirely taken up by a full page of active offers (handled above).
        const transitionSlots = activeCount > 0 && activeLastPageRemainder === 0 ? 0 : pageSize - activeLastPageRemainder;

        const handleOutOfRangePage = () => {
            if (urlPage > 1) {
                const {page: _page, ...restQuery} = ctx.route.query;
                dispatch(enable301ResponseState(appendQueryString(ctx.route.pathname, restQuery)));
            } else {
                dispatch(redirectOrEnable404ResponseState(ctx.route.pathname, ctx.meta));
            }
        };

        const doFetch = async () => {
            if (unavailablePageOffset === 0) {
                // Transition page: active offers already in store, append first slice of unavailable
                const response = await fetchPageOrEmpty(1);
                return {offers: response.results.slice(0, transitionSlots), totalCount: response.count};
            }

            // Global index range (within the combined unavailable sequence) this URL page should cover
            const rangeStart = transitionSlots + (unavailablePageOffset - 1) * pageSize;
            const firstApiPage = unavailablePageOffset;

            const firstResponse = await fetchPageOrEmpty(firstApiPage);
            const totalCount = firstResponse.count;

            if (rangeStart >= totalCount) {
                // Every unavailable offer was already shown on an earlier page — this URL page doesn't exist
                return null;
            }

            const rangeEnd = Math.min(rangeStart + pageSize, totalCount);
            const firstPageGlobalStart = (firstApiPage - 1) * pageSize;
            const fromFirstPage = firstResponse.results.slice(rangeStart - firstPageGlobalStart, rangeEnd - firstPageGlobalStart);

            if (fromFirstPage.length >= rangeEnd - rangeStart || firstResponse.results.length < pageSize) {
                return {offers: fromFirstPage, totalCount};
            }

            // Requested range spills onto the next API page
            const nextResponse = await fetchPageOrEmpty(firstApiPage + 1);
            return {offers: [...fromFirstPage, ...nextResponse.results].slice(0, rangeEnd - rangeStart), totalCount};
        };

        return doFetch()
            .then((fetchResult) => {
                if (fetchResult === null) {
                    handleOutOfRangePage();
                    return;
                }
                dispatch({
                    type: fetchUnavailableOfferListTypes.success,
                    result: {offers: fetchResult.offers, count: fetchResult.totalCount, page: urlPage}
                });
            })
            .catch(
                catch400((error) => {
                    dispatch({type: fetchUnavailableOfferListTypes.error, error: error.appError});
                })
            )
            .catch(catch404(handleOutOfRangePage));
    };
